import { SavedTreeItem, VariableType } from '@selfai-platform/pipeline-common';

export interface NewVariableItem {
  id: string;
  key: string;
  isNewItem: true;
  type: VariableType.VARIABLE;
  parentGroupId?: string;
}

export interface NewGroupItem {
  id: string;
  key: string;
  isNewItem: true;
  type: VariableType.GROUP;
  parentGroupId?: string;
}

export interface PendingNewItem {
  type: VariableType;
  parentGroupId?: string;
}

export type NewTreeItem = NewVariableItem | NewGroupItem;
export type TreeDataItem = SavedTreeItem | NewTreeItem;

export const PENDING_NEW_ITEM_ID = 'pending-new-item';
